var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailySecondPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint0_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint1_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint2_radial_592_6618)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint3_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint4_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint5_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint6_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint7_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 43.9967C38.394 43.9967 45.3906 34.5954 45.3906 22.9983C45.3906 11.4013 38.394 2 24.3923 2C10.3906 2 3.39398 11.4013 3.39398 22.9983C3.39398 34.5954 10.3906 43.9967 24.3923 43.9967Z",
    fill: "url(#paint8_radial_592_6618)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6062 26.6272C18.6087 26.6307 18.6112 26.6342 18.6137 26.6377L18.6113 26.6343L18.6087 26.6306L18.6062 26.6272C18.1283 25.9587 17.1998 25.7988 16.5254 26.2715C15.847 26.7469 15.6824 27.6823 16.1578 28.3607L16.1701 28.3521C16.1699 28.3518 16.1703 28.3524 16.1701 28.3521C16.158 28.3608 16.1587 28.3619 16.1588 28.3621L16.1598 28.3635L16.1619 28.3665L16.1669 28.3735L16.1792 28.3907C16.1886 28.4035 16.2002 28.4193 16.2141 28.4376C16.2418 28.4744 16.2787 28.5217 16.3249 28.5782C16.4172 28.6911 16.5471 28.8409 16.7165 29.0149C17.0547 29.3623 17.5533 29.8098 18.2255 30.2526C19.5808 31.1452 21.6158 31.9999 24.394 31.9999C27.1723 31.9999 29.2073 31.1452 30.5626 30.2526C31.2348 29.8098 31.7334 29.3623 32.0716 29.0149C32.241 28.8409 32.3709 28.6911 32.4632 28.5782C32.5094 28.5217 32.5463 28.4744 32.574 28.4376C32.5879 28.4193 32.5995 28.4035 32.6089 28.3907L32.6212 28.3735L32.6262 28.3665L32.6283 28.3635L32.6293 28.3621C32.6294 28.362 32.6295 28.3618 32.6239 28.3578C32.6236 28.3581 32.6241 28.3574 32.6239 28.3578L32.6303 28.3607C33.1057 27.6823 32.9411 26.7469 32.2627 26.2715C31.5882 25.7988 30.6598 25.9587 30.1819 26.6272C30.1814 26.6278 30.1808 26.6286 30.1801 26.6295C30.1746 26.6367 30.1616 26.6538 30.1407 26.6794C30.0988 26.7305 30.0262 26.8151 29.9218 26.9224C29.7126 27.1374 29.379 27.4399 28.9125 27.7472C27.9902 28.3546 26.5212 28.9999 24.394 28.9999C22.2669 28.9999 20.7979 28.3546 19.8756 27.7472C19.4091 27.4399 19.0755 27.1374 18.8663 26.9224C18.7619 26.8151 18.6893 26.7305 18.6474 26.6794C18.6265 26.6538 18.6141 26.6378 18.6087 26.6306L18.6062 26.6272ZM30.1819 26.6272C30.1793 26.6307 30.1768 26.6342 30.1744 26.6378L30.1768 26.6343L30.1801 26.6295C30.1808 26.6286 30.1814 26.6278 30.1819 26.6272C30.1831 26.6255 30.1827 26.6261 30.1819 26.6272Z",
    fill: "url(#paint9_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5896 7.49958C20.5155 7.86856 21.2954 8.46059 21.8835 9.21149C22.113 9.50451 22.4624 9.68929 22.8341 9.67031C23.7485 9.62364 24.808 9.61375 25.9452 9.67618C26.3187 9.69669 26.6704 9.51118 26.9007 9.2164C27.4893 8.46317 28.2706 7.86936 29.1985 7.49958C29.5002 7.37071 30.021 7.17782 31.3124 6.93707C32.0934 6.79145 33.9516 6.71149 35.206 6.68302C36.5007 6.65363 37.8928 6.65474 38.9337 6.65557L39.4056 6.65583C41.1897 6.65583 42.9498 7.21952 43.6478 7.6402C45.2181 8.43708 46.6712 9.96052 46.7754 12.5821C46.7797 12.6213 46.7825 12.6608 46.7837 12.7006C46.9075 16.7331 44.4033 22.5006 38.0192 24.0812C37.5705 24.1922 37.1294 24.273 36.6871 24.334C36.6656 24.3369 36.644 24.3394 36.6224 24.3414C30.0568 24.9567 25.7582 19.3066 25.6806 13.2555C25.6764 12.9285 25.4248 12.6525 25.0979 12.6432C24.6047 12.6291 24.1337 12.6294 23.6934 12.64C23.3651 12.6479 23.1118 12.9247 23.1077 13.253C23.0335 19.3049 18.7305 24.9567 12.1657 24.3414C12.1441 24.3394 12.1225 24.3369 12.101 24.334C11.6587 24.273 11.2176 24.1922 10.7689 24.0812C4.38476 22.5006 1.88065 16.7331 2.00435 12.7006C2.00557 12.6608 2.00836 12.6213 2.01268 12.5821C2.1169 9.96052 3.57002 8.43708 5.14033 7.6402C5.83832 7.21952 7.59845 6.65583 9.38251 6.65583L9.85437 6.65557C10.8953 6.65474 12.2874 6.65363 13.5821 6.68302C14.8365 6.71149 16.6947 6.79145 17.4757 6.93707C18.7671 7.17782 19.2879 7.37071 19.5896 7.49958ZM4.12981 11.2476C4.50465 10.3347 5.20041 9.58859 6.13709 9.02405C6.66377 8.70661 7.936 8.15583 9.38251 8.15583L9.84863 8.15558C11.9376 8.15391 15.3602 8.15118 16.6423 8.3902C17.885 8.62189 18.2868 8.7906 18.4587 8.86481C19.1629 9.14198 19.777 9.59831 20.245 10.1776L20.7576 12.8994C20.8799 12.8764 21.0304 12.8519 21.2061 12.8275C21.2065 12.8522 21.2067 12.8771 21.2067 12.9019L21.2065 12.9487C21.476 19.2651 16.6657 23.0721 12.1657 22.6503C11.7679 22.5954 11.3795 22.524 10.9894 22.4274C6.24893 21.2538 4.25874 17.5191 3.88011 14.214C3.8218 13.705 3.80171 13.2062 3.81569 12.7285L3.81609 12.7151L3.81911 12.7152L3.81967 12.7006C3.84055 12.1777 3.94702 11.6928 4.12981 11.2476ZM27.5818 12.837C27.5815 12.8586 27.5814 12.8803 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6503C37.0202 22.5954 37.4086 22.524 37.7987 22.4274C42.5392 21.2538 44.5294 17.5191 44.908 14.214C44.9663 13.705 44.9864 13.2062 44.9724 12.7285L44.972 12.7151L44.969 12.7152L44.9684 12.7006C44.9476 12.1777 44.8411 11.6928 44.6583 11.2476C44.2834 10.3347 43.5877 9.58859 42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583L38.9395 8.15558C36.8505 8.15391 33.4279 8.15118 32.1458 8.3902C30.9031 8.62189 30.5013 8.7906 30.3294 8.86481C29.5982 9.15258 28.9642 9.63348 28.4901 10.2446L28.0797 12.9079C27.9131 12.8822 27.7471 12.8586 27.5818 12.837Z",
    fill: "url(#paint10_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5896 7.49958C20.5155 7.86856 21.2954 8.46059 21.8835 9.21149C22.113 9.50451 22.4624 9.68929 22.8341 9.67031C23.7485 9.62364 24.808 9.61375 25.9452 9.67618C26.3187 9.69669 26.6704 9.51118 26.9007 9.2164C27.4893 8.46317 28.2706 7.86936 29.1985 7.49958C29.5002 7.37071 30.021 7.17782 31.3124 6.93707C32.0934 6.79145 33.9516 6.71149 35.206 6.68302C36.5007 6.65363 37.8928 6.65474 38.9337 6.65557L39.4056 6.65583C41.1897 6.65583 42.9498 7.21952 43.6478 7.6402C45.2181 8.43708 46.6712 9.96052 46.7754 12.5821C46.7797 12.6213 46.7825 12.6608 46.7837 12.7006C46.9075 16.7331 44.4033 22.5006 38.0192 24.0812C37.5705 24.1922 37.1294 24.273 36.6871 24.334C36.6656 24.3369 36.644 24.3394 36.6224 24.3414C30.0568 24.9567 25.7582 19.3066 25.6806 13.2555C25.6764 12.9285 25.4248 12.6525 25.0979 12.6432C24.6047 12.6291 24.1337 12.6294 23.6934 12.64C23.3651 12.6479 23.1118 12.9247 23.1077 13.253C23.0335 19.3049 18.7305 24.9567 12.1657 24.3414C12.1441 24.3394 12.1225 24.3369 12.101 24.334C11.6587 24.273 11.2176 24.1922 10.7689 24.0812C4.38476 22.5006 1.88065 16.7331 2.00435 12.7006C2.00557 12.6608 2.00836 12.6213 2.01268 12.5821C2.1169 9.96052 3.57002 8.43708 5.14033 7.6402C5.83832 7.21952 7.59845 6.65583 9.38251 6.65583L9.85437 6.65557C10.8953 6.65474 12.2874 6.65363 13.5821 6.68302C14.8365 6.71149 16.6947 6.79145 17.4757 6.93707C18.7671 7.17782 19.2879 7.37071 19.5896 7.49958ZM4.12981 11.2476C4.50465 10.3347 5.20041 9.58859 6.13709 9.02405C6.66377 8.70661 7.936 8.15583 9.38251 8.15583L9.84863 8.15558C11.9376 8.15391 15.3602 8.15118 16.6423 8.3902C17.885 8.62189 18.2868 8.7906 18.4587 8.86481C19.1629 9.14198 19.777 9.59831 20.245 10.1776L20.7576 12.8994C20.8799 12.8764 21.0304 12.8519 21.2061 12.8275C21.2065 12.8522 21.2067 12.8771 21.2067 12.9019L21.2065 12.9487C21.476 19.2651 16.6657 23.0721 12.1657 22.6503C11.7679 22.5954 11.3795 22.524 10.9894 22.4274C6.24893 21.2538 4.25874 17.5191 3.88011 14.214C3.8218 13.705 3.80171 13.2062 3.81569 12.7285L3.81609 12.7151L3.81911 12.7152L3.81967 12.7006C3.84055 12.1777 3.94702 11.6928 4.12981 11.2476ZM27.5818 12.837C27.5815 12.8586 27.5814 12.8803 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6503C37.0202 22.5954 37.4086 22.524 37.7987 22.4274C42.5392 21.2538 44.5294 17.5191 44.908 14.214C44.9663 13.705 44.9864 13.2062 44.9724 12.7285L44.972 12.7151L44.969 12.7152L44.9684 12.7006C44.9476 12.1777 44.8411 11.6928 44.6583 11.2476C44.2834 10.3347 43.5877 9.58859 42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583L38.9395 8.15558C36.8505 8.15391 33.4279 8.15118 32.1458 8.3902C30.9031 8.62189 30.5013 8.7906 30.3294 8.86481C29.5982 9.15258 28.9642 9.63348 28.4901 10.2446L28.0797 12.9079C27.9131 12.8822 27.7471 12.8586 27.5818 12.837Z",
    fill: "url(#paint11_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5896 7.49958C20.5155 7.86856 21.2954 8.46059 21.8835 9.21149C22.113 9.50451 22.4624 9.68929 22.8341 9.67031C23.7485 9.62364 24.808 9.61375 25.9452 9.67618C26.3187 9.69669 26.6704 9.51118 26.9007 9.2164C27.4893 8.46317 28.2706 7.86936 29.1985 7.49958C29.5002 7.37071 30.021 7.17782 31.3124 6.93707C32.0934 6.79145 33.9516 6.71149 35.206 6.68302C36.5007 6.65363 37.8928 6.65474 38.9337 6.65557L39.4056 6.65583C41.1897 6.65583 42.9498 7.21952 43.6478 7.6402C45.2181 8.43708 46.6712 9.96052 46.7754 12.5821C46.7797 12.6213 46.7825 12.6608 46.7837 12.7006C46.9075 16.7331 44.4033 22.5006 38.0192 24.0812C37.5705 24.1922 37.1294 24.273 36.6871 24.334C36.6656 24.3369 36.644 24.3394 36.6224 24.3414C30.0568 24.9567 25.7582 19.3066 25.6806 13.2555C25.6764 12.9285 25.4248 12.6525 25.0979 12.6432C24.6047 12.6291 24.1337 12.6294 23.6934 12.64C23.3651 12.6479 23.1118 12.9247 23.1077 13.253C23.0335 19.3049 18.7305 24.9567 12.1657 24.3414C12.1441 24.3394 12.1225 24.3369 12.101 24.334C11.6587 24.273 11.2176 24.1922 10.7689 24.0812C4.38476 22.5006 1.88065 16.7331 2.00435 12.7006C2.00557 12.6608 2.00836 12.6213 2.01268 12.5821C2.1169 9.96052 3.57002 8.43708 5.14033 7.6402C5.83832 7.21952 7.59845 6.65583 9.38251 6.65583L9.85437 6.65557C10.8953 6.65474 12.2874 6.65363 13.5821 6.68302C14.8365 6.71149 16.6947 6.79145 17.4757 6.93707C18.7671 7.17782 19.2879 7.37071 19.5896 7.49958ZM4.12981 11.2476C4.50465 10.3347 5.20041 9.58859 6.13709 9.02405C6.66377 8.70661 7.936 8.15583 9.38251 8.15583L9.84863 8.15558C11.9376 8.15391 15.3602 8.15118 16.6423 8.3902C17.885 8.62189 18.2868 8.7906 18.4587 8.86481C19.1629 9.14198 19.777 9.59831 20.245 10.1776L20.7576 12.8994C20.8799 12.8764 21.0304 12.8519 21.2061 12.8275C21.2065 12.8522 21.2067 12.8771 21.2067 12.9019L21.2065 12.9487C21.476 19.2651 16.6657 23.0721 12.1657 22.6503C11.7679 22.5954 11.3795 22.524 10.9894 22.4274C6.24893 21.2538 4.25874 17.5191 3.88011 14.214C3.8218 13.705 3.80171 13.2062 3.81569 12.7285L3.81609 12.7151L3.81911 12.7152L3.81967 12.7006C3.84055 12.1777 3.94702 11.6928 4.12981 11.2476ZM27.5818 12.837C27.5815 12.8586 27.5814 12.8803 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6503C37.0202 22.5954 37.4086 22.524 37.7987 22.4274C42.5392 21.2538 44.5294 17.5191 44.908 14.214C44.9663 13.705 44.9864 13.2062 44.9724 12.7285L44.972 12.7151L44.969 12.7152L44.9684 12.7006C44.9476 12.1777 44.8411 11.6928 44.6583 11.2476C44.2834 10.3347 43.5877 9.58859 42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583L38.9395 8.15558C36.8505 8.15391 33.4279 8.15118 32.1458 8.3902C30.9031 8.62189 30.5013 8.7906 30.3294 8.86481C29.5982 9.15258 28.9642 9.63348 28.4901 10.2446L28.0797 12.9079C27.9131 12.8822 27.7471 12.8586 27.5818 12.837Z",
    fill: "url(#paint12_radial_592_6618)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left Lens"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13713 9.02405C6.66381 8.70661 7.93604 8.15583 9.38255 8.15583C9.52856 8.15583 9.6845 8.1557 9.84867 8.15557C11.9376 8.15391 15.3603 8.15117 16.6423 8.3902C17.885 8.62189 18.2869 8.79059 18.4587 8.86481C20.0682 9.49825 21.2068 11.0675 21.2068 12.9019L21.2065 12.9487C21.4761 19.2651 16.6658 23.0721 12.1658 22.6502C11.7679 22.5954 11.3796 22.524 10.9894 22.4274C5.51177 21.0712 3.70629 16.2956 3.81615 12.7144L3.81915 12.7152C3.87815 11.113 4.73942 9.86646 6.13713 9.02405Z",
    fill: "url(#paint13_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13713 9.02405C6.66381 8.70661 7.93604 8.15583 9.38255 8.15583C9.52856 8.15583 9.6845 8.1557 9.84867 8.15557C11.9376 8.15391 15.3603 8.15117 16.6423 8.3902C17.885 8.62189 18.2869 8.79059 18.4587 8.86481C20.0682 9.49825 21.2068 11.0675 21.2068 12.9019L21.2065 12.9487C21.4761 19.2651 16.6658 23.0721 12.1658 22.6502C11.7679 22.5954 11.3796 22.524 10.9894 22.4274C5.51177 21.0712 3.70629 16.2956 3.81615 12.7144L3.81915 12.7152C3.87815 11.113 4.73942 9.86646 6.13713 9.02405Z",
    fill: "url(#paint14_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13713 9.02405C6.66381 8.70661 7.93604 8.15583 9.38255 8.15583C9.52856 8.15583 9.6845 8.1557 9.84867 8.15557C11.9376 8.15391 15.3603 8.15117 16.6423 8.3902C17.885 8.62189 18.2869 8.79059 18.4587 8.86481C20.0682 9.49825 21.2068 11.0675 21.2068 12.9019L21.2065 12.9487C21.4761 19.2651 16.6658 23.0721 12.1658 22.6502C11.7679 22.5954 11.3796 22.524 10.9894 22.4274C5.51177 21.0712 3.70629 16.2956 3.81615 12.7144L3.81915 12.7152C3.87815 11.113 4.73942 9.86646 6.13713 9.02405Z",
    fill: "url(#paint15_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13713 9.02405C6.66381 8.70661 7.93604 8.15583 9.38255 8.15583C9.52856 8.15583 9.6845 8.1557 9.84867 8.15557C11.9376 8.15391 15.3603 8.15117 16.6423 8.3902C17.885 8.62189 18.2869 8.79059 18.4587 8.86481C20.0682 9.49825 21.2068 11.0675 21.2068 12.9019L21.2065 12.9487C21.4761 19.2651 16.6658 23.0721 12.1658 22.6502C11.7679 22.5954 11.3796 22.524 10.9894 22.4274C5.51177 21.0712 3.70629 16.2956 3.81615 12.7144L3.81915 12.7152C3.87815 11.113 4.73942 9.86646 6.13713 9.02405Z",
    fill: "url(#paint16_radial_592_6618)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Left Lens Highlight",
    cx: 17.1027,
    cy: 12.7142,
    rx: 2.24128,
    ry: 2.81866,
    transform: "rotate(-25.8832 17.1027 12.7142)",
    fill: "url(#paint17_linear_592_6618)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right Lens"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583C39.2596 8.15583 39.1036 8.1557 38.9395 8.15557C36.8505 8.15391 33.4279 8.15117 32.1458 8.3902C30.9031 8.62189 30.5013 8.79059 30.3294 8.86481C28.7199 9.49825 27.5814 11.0675 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6502C37.0202 22.5954 37.4086 22.524 37.7988 22.4274C43.2764 21.0712 45.0819 16.2956 44.972 12.7144L44.969 12.7152C44.91 11.113 44.0487 9.86646 42.651 9.02405Z",
    fill: "url(#paint18_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583C39.2596 8.15583 39.1036 8.1557 38.9395 8.15557C36.8505 8.15391 33.4279 8.15117 32.1458 8.3902C30.9031 8.62189 30.5013 8.79059 30.3294 8.86481C28.7199 9.49825 27.5814 11.0675 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6502C37.0202 22.5954 37.4086 22.524 37.7988 22.4274C43.2764 21.0712 45.0819 16.2956 44.972 12.7144L44.969 12.7152C44.91 11.113 44.0487 9.86646 42.651 9.02405Z",
    fill: "url(#paint19_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583C39.2596 8.15583 39.1036 8.1557 38.9395 8.15557C36.8505 8.15391 33.4279 8.15117 32.1458 8.3902C30.9031 8.62189 30.5013 8.79059 30.3294 8.86481C28.7199 9.49825 27.5814 11.0675 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6502C37.0202 22.5954 37.4086 22.524 37.7988 22.4274C43.2764 21.0712 45.0819 16.2956 44.972 12.7144L44.969 12.7152C44.91 11.113 44.0487 9.86646 42.651 9.02405Z",
    fill: "url(#paint20_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.651 9.02405C42.1243 8.70661 40.8521 8.15583 39.4056 8.15583C39.2596 8.15583 39.1036 8.1557 38.9395 8.15557C36.8505 8.15391 33.4279 8.15117 32.1458 8.3902C30.9031 8.62189 30.5013 8.79059 30.3294 8.86481C28.7199 9.49825 27.5814 11.0675 27.5814 12.9019L27.5816 12.9487C27.3121 19.2651 32.1224 23.0721 36.6224 22.6502C37.0202 22.5954 37.4086 22.524 37.7988 22.4274C43.2764 21.0712 45.0819 16.2956 44.972 12.7144L44.969 12.7152C44.91 11.113 44.0487 9.86646 42.651 9.02405Z",
    fill: "url(#paint21_radial_592_6618)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Right Lens Highlight",
    cx: 41.154,
    cy: 12.7142,
    rx: 2.24128,
    ry: 2.81866,
    transform: "rotate(-25.8832 41.154 12.7142)",
    fill: "url(#paint22_linear_592_6618)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.584 30.0725L40.072 34.3223L36.5623 35.3204C34.138 34.5182 32.71 32.9762 31.8492 31.3913C31.4862 30.7229 31.4891 29.4951 32.9319 29.4951H36.577C36.9914 29.4951 37.3746 29.7149 37.584 30.0725Z",
    fill: "#4686EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.584 30.0725L40.072 34.3223L36.5623 35.3204C34.138 34.5182 32.71 32.9762 31.8492 31.3913C31.4862 30.7229 31.4891 29.4951 32.9319 29.4951H36.577C36.9914 29.4951 37.3746 29.7149 37.584 30.0725Z",
    fill: "url(#paint23_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.584 30.0725L40.072 34.3223L36.5623 35.3204C34.138 34.5182 32.71 32.9762 31.8492 31.3913C31.4862 30.7229 31.4891 29.4951 32.9319 29.4951H36.577C36.9914 29.4951 37.3746 29.7149 37.584 30.0725Z",
    fill: "url(#paint24_linear_592_6618)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.788 30.0725L37.2999 34.3223L40.8097 35.3204C43.2339 34.5182 44.6619 32.9762 45.5227 31.3913C45.8858 30.7229 45.8828 29.4951 44.44 29.4951H40.795C40.3806 29.4951 39.9973 29.7149 39.788 30.0725Z",
    fill: "#4686EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.788 30.0725L37.2999 34.3223L40.8097 35.3204C43.2339 34.5182 44.6619 32.9762 45.5227 31.3913C45.8858 30.7229 45.8828 29.4951 44.44 29.4951H40.795C40.3806 29.4951 39.9973 29.7149 39.788 30.0725Z",
    fill: "url(#paint25_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.788 30.0725L37.2999 34.3223L40.8097 35.3204C43.2339 34.5182 44.6619 32.9762 45.5227 31.3913C45.8858 30.7229 45.8828 29.4951 44.44 29.4951H40.795C40.3806 29.4951 39.9973 29.7149 39.788 30.0725Z",
    fill: "url(#paint26_linear_592_6618)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 778",
    d: "M39.788 30.0725L37.2999 34.3223L40.8097 35.3204C43.2339 34.5182 44.6619 32.9762 45.5227 31.3913C45.8858 30.7229 45.8828 29.4951 44.44 29.4951H40.795C40.3806 29.4951 39.9973 29.7149 39.788 30.0725Z",
    fill: "url(#paint27_linear_592_6618)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 169"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.7581,
    cy: 39.7456,
    r: 5.8622,
    fill: "url(#paint28_linear_592_6618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7581,
    cy: 39.7456,
    r: 5.8622,
    fill: "url(#paint29_linear_592_6618)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 170",
    cx: 38.7581,
    cy: 39.7456,
    rx: 5.06909,
    ry: 5.06909,
    fill: "url(#paint30_linear_592_6618)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7581,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint31_linear_592_6618)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7581,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint32_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7581,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint33_radial_592_6618)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7581,
    cy: 39.7456,
    rx: 4.42529,
    ry: 4.42529,
    fill: "url(#paint34_radial_592_6618)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M39.919 42.3359H37.6028C37.3752 42.3359 37.171 42.2076 37.0718 41.9976C36.9727 41.7934 37.0018 41.5483 37.1477 41.3733L39.073 39.0104C39.2247 38.8237 39.1547 38.6253 39.1314 38.5669C39.1022 38.4969 39.0089 38.3394 38.793 38.3336C38.7872 38.3336 38.7755 38.3336 38.7638 38.3336C38.5771 38.3336 38.4079 38.4211 38.2971 38.5728C38.1104 38.8353 37.7428 38.8995 37.4744 38.7128C37.206 38.5261 37.1477 38.1585 37.3344 37.8902C37.6611 37.4292 38.192 37.155 38.758 37.155C38.7872 37.155 38.8105 37.155 38.8338 37.155C39.4289 37.1842 39.9482 37.5401 40.1932 38.0827C40.4441 38.6428 40.3624 39.2787 39.9774 39.7513L38.8397 41.1516H39.9132C40.2399 41.1516 40.5025 41.4141 40.5025 41.7408C40.5025 42.0676 40.2457 42.3359 39.919 42.3359Z",
    fill: "#6A6372"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.644 12.5) rotate(131.878) scale(58.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.394 17.75) rotate(101.31) scale(26.7699 34.2871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.394 20) rotate(135) scale(61.5183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.394 24.5) rotate(77.692) scale(42.2204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.144 23.75) rotate(55.7131) scale(19.9703 14.4755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.144 26) rotate(9.86581) scale(17.5089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.644 21.5) rotate(43.9708) scale(88.5794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0325 16.6713) rotate(124.346) scale(9.43073 11.5858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.440361,
    stopColor: "#BC6533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6533",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7276 16.1627) rotate(67.4259) scale(11.0904)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.538073,
    stopColor: "#BC6533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6533",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.394 25.722) rotate(90) scale(16.4063 25.3026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#2E1529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342857,
    stopColor: "#4B2744"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.0814 7.62849) rotate(78.8614) scale(18.4411 38.2144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3085"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.23 15.5202) rotate(78.0636) scale(8.27146 9.29219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#77579C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#77579C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2064 14.0035) rotate(-122.735) scale(7.0214 5.1541)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.769354,
    stopColor: "#4E3D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534687",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4253 12.5972) rotate(121.845) scale(8.88414 10.0926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361C5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5974 12.8316) rotate(87.1376) scale(11.2641 16.7264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.647365,
    stopColor: "#5B2B84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B2B84"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0661 24.1754) rotate(-99.5134) scale(17.3004 17.1323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.858612,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5193 11.7066) rotate(102.225) scale(11.511 10.8033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.872281,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_592_6618",
    x1: 18.0834,
    y1: 10.6931,
    x2: 15.9931,
    y2: 15.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3784 11.9879) rotate(121.289) scale(9.92832 14.9132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361C5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1907 12.8316) rotate(92.8624) scale(11.2641 16.7264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.647365,
    stopColor: "#5B2B84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B2B84"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2737 22.1597) rotate(-77.6023) scale(15.4061 15.2564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.858612,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2689 11.7066) rotate(77.7749) scale(11.511 10.8033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.872281,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_592_6618",
    x1: 42.1347,
    y1: 10.6931,
    x2: 40.0444,
    y2: 15.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0404 34.9089) rotate(-123.321) scale(2.68587 10.0306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3669D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3669D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_592_6618",
    x1: 33.2357,
    y1: 29.1805,
    x2: 34.2831,
    y2: 31.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D89EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D89EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3315 34.9089) rotate(-57.2648) scale(1.77873 3.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3669D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3669D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_592_6618",
    x1: 44.1362,
    y1: 29.1805,
    x2: 43.0888,
    y2: 31.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D89EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D89EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_592_6618",
    x1: 38.5839,
    y1: 32.1211,
    x2: 38.781,
    y2: 32.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6DD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_592_6618",
    x1: 43.2797,
    y1: 36.7151,
    x2: 37.826,
    y2: 41.7015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_592_6618",
    x1: 36.7096,
    y1: 45.8927,
    x2: 38.0317,
    y2: 38.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0A9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A9F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_592_6618",
    x1: 43.3767,
    y1: 38.8598,
    x2: 38.7581,
    y2: 38.8598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_592_6618",
    x1: 35.9805,
    y1: 40.8955,
    x2: 43.3452,
    y2: 38.6671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0D3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1B0D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4374 39.0747) rotate(156.644) scale(6.64943 5.66604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.837399,
    stopColor: "#F6ECFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1928 40.2704) rotate(-41.2938) scale(5.22992 5.02174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.909611,
    stopColor: "#B396CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991989,
    stopColor: "#B796D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_592_6618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6304 39.377) rotate(37.9308) scale(4.9236 5.57961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925972,
    stopColor: "#AB9CBB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB9CBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailySecondPrice);
export default __webpack_public_path__ + "static/media/daily_second_price.5645613290d64d351c554c757aa882b0.svg";
export { ForwardRef as ReactComponent };